import { Component, OnInit, inject } from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {CaptchaService} from '@shared/services/captcha.service';
import { Subject } from 'rxjs';
import { RecaptchaModule } from 'ng-recaptcha';

@Component({
    selector: 'app-captcha-modal',
    templateUrl: './captcha-modal.component.html',
    imports: [RecaptchaModule]
})
export class CaptchaModalComponent implements OnInit {
    bsModalRef = inject(BsModalRef);
    private captchaService = inject(CaptchaService);

    public onClose: Subject<string>;

    public ngOnInit(): void {
      this.onClose = new Subject();
   }

    resolved(captchaResponse: string) {
        this.captchaService.newCaptcha(captchaResponse);
        this.onClose.next(captchaResponse);
        this.bsModalRef.hide();
    }

}
